<button class="normalized-button" mat-icon-button (click)="onFilterClick()">
    <mat-icon>filter_list</mat-icon>
</button>  